import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationService } from '@cbuild/core';

function adjustToTimeZone(value: string, offset: number): number {
  const date = new Date(value);
  // Adjust to the given timezone offset
  return date.getTime() + offset + date.getTimezoneOffset() * 60000;
}

@Pipe({
  name: 'fromUTC',
  standalone: false
})
export class FromUTCPipe extends DatePipe implements PipeTransform {
  private timeOffset: number;
  private timeZone: string;

  constructor(applicationService: ApplicationService) {
    super(applicationService.locale);
    this.timeOffset = applicationService.basicInfo!.timeOffset || 0;
    this.timeZone = applicationService.basicInfo!.timeZoneCode || '';
  }

  public transform(
    value: string | number | Date | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): string | null;
  public transform(
    value: null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): null;
  public transform(
    value: string | number | Date | null | undefined,
    format: string = 'short',
    timezone: string = 'include',
    locale?: string
  ): string | null {
    if (value === null || value === undefined) {
      return null;  // Handle null or undefined value
    }

    // Ensure value is in a proper string format with 'Z' if necessary
    let valueStr = typeof value === 'string' ? value : new Date(value).toISOString();
    valueStr = !valueStr.endsWith('Z') ? `${valueStr}Z` : valueStr;

    const timestamp = this.timeOffset
      ? adjustToTimeZone(valueStr, this.timeOffset)
      : new Date(valueStr).getTime();

    const returnValue = super.transform(timestamp, format, timezone, locale);

    // Return formatted value, optionally appending the time zone
    return this.timeZone && timezone === 'include'
      ? `${returnValue} (${this.timeZone})`
      : returnValue;
  }
}
